const pricePerDesk = (space, team_size = 1) => {
  const ts = Number(team_size)
  const p_min = space.price_min ? Number(space.price_min) : space.price_per_desk
  const p_max = space.price_max ? Number(space.price_max) : space.price_per_desk
  if (p_max <= p_min) {
    return `$${(p_min / ts).toLocaleString("en")}`
  }
  return `$${(p_min / ts).toLocaleString("en")}+`
}

export default pricePerDesk
